/*
 * @author: xd
 * @Date: 2021-12-15 13:05:12
 * @LastEditors: xd
 * @LastEditTime: 2022-03-30 13:26:13
 * @Description: 功能
 */
import { BaseClass } from "../base/DreamScape";
import { Secret } from "../modules/Secret/secret";

export  class   Cache extends BaseClass {
  constructor() {
    super();
  }
  static getsec(str: string): number {
    // alert(str);
    var str1: number = 8;
    str1 = Number(str.substring(1, str.length)) * 1;
    var str2 = str.substring(0, 1);
    if (str2 == "s") {
      return str1 * 1000;
    } else if (str2 == "h") {
      return str1 * 60 * 60 * 1000;
    } else if (str2 == "d") {
      return str1 * 24 * 60 * 60 * 1000;
    } else {
      return str1;
    }
  }
  static GetCookieName(name: string): string {
    // var arr,
    //   reg = new RegExp("(^| )" + name + "=([^;]*)(;|$)");
    // if ((arr == document.cookie.match(reg))) {
    //   return decodeURIComponent(arr[2]);
    // } else {
    //   return "";
    // }
    let ss = new Secret();
    var strcookie = document.cookie;
    var arrcookie = strcookie.split("; ");
    for (var i = 0; i < arrcookie.length; i++) {
      var arr = arrcookie[i].split("=");
      if (arr[0] == name) {
        if (name != "sytoken"&&name != "mUserName") {
          return ss.Decrypt1(arr[1]);
        } else {
          return unescape(arr[1]);
        }
      }
    }
    return "";
  }
  static SetTokenCookie(name: string, value: string, time: string) {
 

    var strsec = this.getsec(time);
    var exp = new Date();
    exp.setTime(exp.getTime() + strsec * 1);
    document.cookie =
      name +
      "=" +
      value +
      ";expires=" +
      exp.toUTCString() +
      "; path=/;";
  }
  static SetCookie(name: string, value: string, time: string) {
    let ss = new Secret();
    if (name != "sytoken"&&name != "mUserName") {
      value = ss.Encrypt1(value);
    }

    

    var strsec = this.getsec(time);
    var exp = new Date();
    exp.setTime(exp.getTime() + strsec * 1);
    document.cookie =
      name +
      "=" +
      escape(value) +
      ";expires=" +
      exp.toUTCString() +
      "; path=/;";
  }
  //删除cookies
  static DelCookie(name: string) {
    var exp = new Date();
    exp.setTime(exp.getTime() - 1);
    var cval = this.GetCookieName(name);
    if (cval != null)
      document.cookie = name + "=" + cval + ";expires=" + exp.toUTCString();
  }

  static SetLocalStorageJson(name: string, json: any) {
    let ss = new Secret();
    localStorage.setItem(name, ss.Encrypt1(JSON.stringify(json)));
  }

  static GetLocalStorageJson(name: string): any {
    let ss = new Secret();
    let val = localStorage.getItem(name);
    if (val) {
      return JSON.parse(ss.Decrypt1(val));
    } else {
      return null;
    }
  }

  static SetLocalStorageString(name: string, val: string) {
    let ss = new Secret();
    if (name != "sytoken") {
      val = ss.Encrypt1(val);
    }
    localStorage.setItem(name, val);
  }

  static GetLocalStorageString(name: string): any {
    let ss = new Secret();
    let val = localStorage.getItem(name);
    if (val) {
      return ss.Decrypt1(val);
    } else {
      return "";
    }
  }
}
